import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b45c2918"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shop" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-2 center mb-4" }, "Shop", -1))
const _hoisted_3 = { class: "shopContainer" }
const _hoisted_4 = { class: "productContainer" }
const _hoisted_5 = { class: "layout gutter--md" }
const _hoisted_6 = { class: "row justify--space-around" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "center" }
const _hoisted_9 = { class: "row justify--center align--center mt-2" }
const _hoisted_10 = {
  key: 0,
  class: "flex md6"
}
const _hoisted_11 = { class: "flex md12" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Føj til kurv")
const _hoisted_13 = { class: "display-4 center" }
const _hoisted_14 = { class: "layout gutter--md" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "flex md4" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Pris:", -1))
const _hoisted_18 = { class: "flex md12 lineBreak" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Beskrivelse:", -1))
const _hoisted_20 = { class: "row justify--center" }
const _hoisted_21 = { class: "flex" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_23 = { class: "layout gutter--md" }
const _hoisted_24 = { class: "row justify--center" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Du kan nu vælge følgende", -1))
const _hoisted_26 = { class: "row justify--center" }
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Forsæt")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Gå til kassen")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_it_modal = _resolveComponent("it-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex productBox",
                key: index
              }, [
                _createVNode(_component_va_popover, {
                  class: "moreInfoBtn",
                  message: "Mere Info",
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "moreInfoBtn",
                      onClick: ($event: any) => (_ctx.getMoreInfo(product.id))
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("p", null, _toDisplayString(product.name), 1),
                        _createElementVNode("p", null, _toDisplayString(product.price + ' kr.'), 1)
                      ])
                    ], 8, _hoisted_7)
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("div", _hoisted_9, [
                  (!product.onlySingle)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_va_input, {
                          modelValue: product.counter,
                          "onUpdate:modelValue": ($event: any) => ((product.counter) = $event),
                          modelModifiers: { number: true },
                          type: "number",
                          label: "Antal"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_va_button, {
                      size: "small",
                      onClick: ($event: any) => (_ctx.addProductToCart(product.id))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.productInfoModal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productInfoModal) = $event))
    }, {
      header: _withCtx(() => [
        _createElementVNode("h4", _hoisted_13, _toDisplayString('Information om ' + _ctx.productInfo.produkt_navn), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("p", null, [
                _hoisted_17,
                _createTextVNode(" " + _toDisplayString(_ctx.productInfo.produkt_pris + ' kr.'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_va_divider),
              _createElementVNode("p", null, [
                _hoisted_19,
                _createTextVNode(" " + _toDisplayString(_ctx.productInfo.produkt_beskrivelse), 1)
              ])
            ])
          ])
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_va_button, {
              color: "secondary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.productInfoModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_22
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.confirmationModal,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.confirmationModal) = $event))
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("p", null, _toDisplayString(_ctx.confirmationMessage), 1),
            _hoisted_25
          ])
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_va_button, {
              class: "mr-2",
              color: "secondary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmationModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_28
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "ml-2",
              color: "success",
              onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.confirmationModal = false;_ctx.$router.push('/kassen')})
            }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}